import React, { Component } from 'react'
import { Link } from 'react-router'

import cn from 'classnames'
import s from './Crumbs.scss'
import sLay from 'styles/modules/layout.scss'

export default class Crumb extends Component {
  render() {
    const { to, children, parent, active, onClick } = this.props
    return (
      <div className={cn(s.crumb, sLay['layout-row'], sLay['layout-align-start-center'])}>
        {to ? (
          <Link className={cn(s.crumb, { [s.active]: active })} to={to} onClick={onClick}>
            {children}
          </Link>
        ) : (
          <a className={cn(s.crumb, { [s.active]: active })} onClick={onClick}>
            {children}
          </a>
        )}
        {parent && <div className={s.circle} />}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/BreadCrumbs/Crumb.jsx